import React from 'react';

import { ReactComponent as Logo } from 'assets/images/logo.svg';
import useFixedBody from 'hooks/useFixedBody';
import './styles.scss';

const Loader = () => {
  useFixedBody(true);

  return (
    <div className="loader-container" >
      <div className="logo">
        <Logo />
      </div>
    </div>
  );
};

export default Loader;
